import styled from "styled-components";
import { RichText } from "@nested/brand";
import { SignUpForm } from "../../../components/RebrandSignUpForm/SignUpForm";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";

const Wrapper = styled.div`
  padding: 20px 0px;
`;

export const EmailSignUp = ({ heading }) => (
  <div css={blogWrapperStyles}>
    <Wrapper>
      <RichText center>{heading}</RichText>
      <SignUpForm highContrast />
    </Wrapper>
  </div>
);
